module.exports = __webpack_public_path__ + "img/svg/step2.93d470399e0e2807905f78a1a393c503.svg";